module.exports = __webpack_public_path__ + "media/abius.10f4d80a.mp4";